(() => {
  const clipboardButtons = document.querySelectorAll('[data-clipboard]');

  clipboardButtons.forEach((clipboardButton) => {
    clipboardButton.addEventListener('click', copyValue);
  });

  function copyValue(e) {
    const target = e.currentTarget;
    const value = target.dataset.clipboard;

    navigator.clipboard
      .writeText(value)
      .then(() => {
        if (target.dataset.clipboardSuccess) {
          target.querySelector('.status-text').innerHTML = target.dataset.clipboardSuccess;
        }
      });
  }
})();
